import ActionMenu from "../../../components/ui/materialui/actionMenu";
import { RowComprobanteLiquidacion } from "../models/headerComprobanteLiquidacion";

interface IProps{
    setRowSelected?: any;
    setShowFormulario?: any;
    setIsCreating: any;
    row: RowComprobanteLiquidacion
    setShowEliminacion?: any
}

const AccionesLiquidacion: React.FC<IProps> = ({row, setRowSelected, setShowFormulario, setIsCreating, setShowEliminacion }) => {

    let actions = [
        { label: "Editar Beneficiario", icon: <></>, onClick: () => {setRowSelected(row); setShowFormulario(true); setIsCreating(false); }},
        { label: "Eliminar Beneficiario", icon: <></>, onClick: () => {setRowSelected(row); setShowEliminacion(row);}}
    ];

    return(<>
        <ActionMenu actions={actions} />
    </>)
}

export default AccionesLiquidacion;